























































import EhrButton from "./interface/EhrButton.vue";
import Vue from "vue";
declare var GLOBAL_applicationName: string;
declare var GLOBAL_logo: string;
export default Vue.extend({
  name: "access-denied",
  components: { EhrButton },
  props: {
    // "module-denied", "application-denied", "not-found"
    denyType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      logo: GLOBAL_logo,
    };
  },
  computed: {
    applicationName() {
      return GLOBAL_applicationName;
    },
  },
  methods: {
    logout(): void {
      window.location.href = document.baseURI + "logout";
    },
    returnToHome(): void {
      window.location.href = document.baseURI;
    },
  },
});
